import { LegalPage } from '../components/LegalPage';

const PrivacyPolicyPage = () => <LegalPage doc="privacy" testId="privacy-policy-page" />;

export default PrivacyPolicyPage;
